import React from 'react';
import PropTypes from 'prop-types';

const numOrNull = (v) => (v === '' ? null : Number(v));

const SOLD_BY_OPTIONS = [
  { value: '', label: 'Select…' },
  { value: 'artist', label: 'Artist' },
  { value: 'venue', label: 'Venue' },
  { value: '3rd_party', label: '3rd-party' },
];

const SoldBySelect = ({ value, onChange }) => (
  <select
    className="simple-mod__select"
    value={value || ''}
    onChange={(e) => onChange(e.target.value)}
  >
    {SOLD_BY_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
  </select>
);

SoldBySelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

SoldBySelect.defaultProps = { value: '' };

// Merchandising fields styled to match the simple-offer prototype: a pill
// switch gates two rows of [rate %, sold-by, notes] plus a full-width
// additional-notes field.
const SimpleMerchandisingSection = ({ offer, onChangeField }) => {
  const on = !!offer.has_merchandising;

  const rateField = (label, key) => (
    <label className="simple-mod__field">
      <span className="simple-mod__label">{label}</span>
      <span className="simple-mod__input-wrap">
        <input
          type="number"
          step="0.01"
          className="simple-mod__input simple-mod__input--suffix"
          placeholder="0.0"
          value={offer[key] ?? ''}
          onChange={(e) => onChangeField(key, numOrNull(e.target.value))}
        />
        <span className="simple-mod__affix simple-mod__affix--suffix"><i className="fas fa-percent" aria-hidden="true" /></span>
      </span>
    </label>
  );

  const notesField = (label, key) => (
    <label className="simple-mod__field">
      <span className="simple-mod__label">{label}</span>
      <input
        type="text"
        className="simple-mod__input"
        value={offer[key] ?? ''}
        onChange={(e) => onChangeField(key, e.target.value)}
      />
    </label>
  );

  return (
    <div className="simple-mod" data-testid="modifiers-subsection-merch">
      {on && (
        <div className="simple-mod__grid simple-mod__grid--merch">
          {rateField('Soft Merch Rate (artist %)', 'soft_merch_rate')}
          <label className="simple-mod__field">
            <span className="simple-mod__label">Sold by</span>
            <SoldBySelect value={offer.soft_merch_sold_by} onChange={(v) => onChangeField('soft_merch_sold_by', v)} />
          </label>
          {notesField('Soft Merch Notes', 'soft_merch_notes')}

          {rateField('Hard Merch Rate (artist %)', 'hard_merch_rate')}
          <label className="simple-mod__field">
            <span className="simple-mod__label">Sold by</span>
            <SoldBySelect value={offer.hard_merch_sold_by} onChange={(v) => onChangeField('hard_merch_sold_by', v)} />
          </label>
          {notesField('Hard Merch Notes', 'hard_merch_notes')}

          <label className="simple-mod__field simple-mod__field--full">
            <span className="simple-mod__label">Additional Merch Notes</span>
            <input
              type="text"
              className="simple-mod__input"
              value={offer.addl_merch_notes ?? ''}
              onChange={(e) => onChangeField('addl_merch_notes', e.target.value)}
            />
          </label>
        </div>
      )}
    </div>
  );
};

SimpleMerchandisingSection.propTypes = {
  offer: PropTypes.object.isRequired,
  onChangeField: PropTypes.func.isRequired,
};

export default SimpleMerchandisingSection;
